export function wrapSelectedText(selectedEl: HTMLElement | null, templateHtml: string) {
    const selection = window.getSelection();
    if (!selection || !selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    if (!selectedEl?.contains(range.commonAncestorContainer)) return;

    // Seçili HTML'i al
    const div = document.createElement("div");
    div.appendChild(range.cloneContents());
    const selectedHtml = div.innerHTML;
    if (!selectedHtml) return;

    // wrap HTML içine seçili HTML'i koy
    const wrappedHtml = templateHtml.replace("{{selected}}", selectedHtml);

    // Mevcut range'i sil
    range.deleteContents();

    // HTML parse edip fragment oluştur
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = wrappedHtml;

    const frag = document.createDocumentFragment();
    while (tempDiv.firstChild) {
        frag.appendChild(tempDiv.firstChild);
    }

    // fragment'i ekle
    range.insertNode(frag);

    // Caret'i son elemana taşı
    const lastNode = frag.lastChild;
    if (lastNode) {
        const newRange = document.createRange();
        newRange.setStartAfter(lastNode);
        newRange.collapse(true);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
